import React from "react";

function fileDropArea({onFileDropped, onDragOver, onDragEnd, className, children}) {
  function preventEvents(e) {
    e.preventDefault();
    e.stopPropagation();
  }
  function _onDragOver(e) {
    preventEvents(e);
    onDragOver(e);
  }
  function _onDragEnter(e) {
    preventEvents(e);
    onDragOver(e);
  }
  function _onDragLeave(e) {
    preventEvents(e);
    onDragEnd(e);
  }
  function _onDragEnd(e) {
    preventEvents(e);
    onDragEnd(e);
  }
  function _onDrop(e) {
    preventEvents(e);
    onDragEnd(e);
    onFileDropped(e.dataTransfer.files);
  }

  const handlers = {
    onDrag: preventEvents,
    onDragStart: preventEvents,
    onDragEnd: _onDragEnd,
    onDragOver: _onDragOver,
    onDragEnter: _onDragEnter,
    onDragLeave: _onDragLeave,
    onDrop: _onDrop,
  };
  return (
    <div className={className} {...handlers}>
      {children}
    </div>
  );
}

export default fileDropArea;
